export const AUTO_FILL_APPLICATION_KEY = 'enroll@debug_auto_fill_application'
export const AUTO_FILL_ZIP_KEY = 'enroll@debug_auto_fill_zip'
export const AUTO_FILL_ENROLLEES_KEY = 'enroll@debug_auto_fill_enrollees'
export const AUTO_FILL_QULIFY_KEY = 'enroll@debug_auto_fill_quilify'